import { connect } from "react-redux";
import { SearchBox } from "../presentation/SearchBox";
import { QueryUpdatedThunk } from "../../store/actions/QueryUpdatedThunk";
import { ThunkDispatch, ThunkAction } from "redux-thunk";

interface PropsFromState {
}

interface PropsFromDispatch {
    query: (query: string) => ThunkAction<any, any, any, any>;
}

interface OwnProps {
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, any>) => ({
    query: (query: string) => dispatch(QueryUpdatedThunk(query))
});

export const SearchBoxContainer = connect<PropsFromState, PropsFromDispatch, OwnProps>(undefined, mapDispatchToProps)(SearchBox);